module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Devices/iPhone-x-back-27106927574ba009ffd6b9dc05405f17.svg";